(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("freeTrial", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/types/freeTrialView.html",
            controller: ["subscriptionResource", "messageService", FreeTrialCtrl],
            controllerAs: "vm"
        };
        function FreeTrialCtrl(subscriptionResource, messageService) {
            var vm = this;
            vm.maxUsersToContactAdmin = 1000;
            vm.loading = true;
            subscriptionResource.getSubscriptionViewModel(function (result) {
                vm.subscription = result;
                //vm.calculatorView = "app/settings/subscription/types/calculatorView.html";
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
    });
}());
